var Handlebars = require("../../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"fr-n-page-hits-selected\">\n    ( "
    + alias2(alias1((depth0 != null ? depth0.numberAppliedHits : depth0), depth0))
    + " / "
    + alias2(alias1((depth0 != null ? depth0.numberHits : depth0), depth0))
    + " selected )\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/hitSelectedCount/template.hbs
 ** module id = 623
 ** module chunks = 0
 **/